module.exports = __webpack_public_path__ + "static/img/title.d313c5cd.png";